module.exports = __webpack_public_path__ + "img/411.2ba94491.jpg";